import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import TopSection from '../../../LT/TopSection'
import { DataDetails } from './DataDetails'
import { Loader } from '../../../../components/common/Loader';
import { fetchPriceMemoMaintenanceData } from '../../../../redux/actions/PriceMemoMaintenance';
import { priceMemoMaintenanceDataEndpoint } from '../../../../common/endpoints';
import { toast } from 'react-toastify';

export const PackViewerPriceMemo = () => {
  const dispatch = useDispatch();
  const procurementDivisionType = useSelector((state) => state?.userCardType?.procurementDivisionType);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
//   const [rowsData, setRowsData] = useState([]);
//   const [btnDisabled, setIsBtnDisabled] = useState(true);
  const pmMaintenanceDataList = useSelector((state) => state?.PriceMemoMaintenanceSlice);
  const gridApiRef = useRef(null);

  const userName = localStorage.getItem("data");
  const region = localStorage.getItem("CDRegion");

  const cleanUsername = (name) => {
    return name.replace(/\s*\[C\]/, ""); // Removes "[C]" with optional leading space
  };

  const pagination = false;

  const getPmOwnerData = useCallback( async () => {
    setLoading(true);
    try {
      const response = await dispatch(
          fetchPriceMemoMaintenanceData({
            dynamicEndpoint: `${priceMemoMaintenanceDataEndpoint}/${procurementDivisionType.toLowerCase()}/getPriceMemo?userName=${cleanUsername(userName)}&region=${region}`,
          })
        );
        if (response?.meta?.requestStatus === 'fulfilled') {
          setLoading(false);
        } else {
          setLoading(false);
          toast.error(`${response?.payload?.errorMessage}`);
          console.error('Failed to fetch data:', response.error);
        }
    } catch(error){
      setLoading(false);
      toast.error("Error fetching Price Memo Maintenance data");
      console.error("Error fetching Price Memo Maintenance data:", error);
    }
    
  }, [dispatch, procurementDivisionType, userName, region]);

  useEffect(() => {
      getPmOwnerData();
    }, [getPmOwnerData]);

  return (
    <>
      <TopSection
        labelList={[
            { title: "Home", path: "/landing-page" },
            { title: "Price Memo Management" },
        ]}
        hideHeader={true}
        headerName={"Price Memo Management"}
        />
        {
          loading ? <Loader />
          :
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <div className="priceMemo_main">
            {loading ? (
              <Loader />
            ) : !pmMaintenanceDataList?.data ? (
              <div style={{ textAlign: "center", fontWeight: "bold" }}>
                No record found
              </div>
            ) : (
              <div className="priceMemo_dataTable">
                <DataDetails
                 
                  data={pmMaintenanceDataList?.data}
                  gridApiRef={gridApiRef}
                  setRowsData={setTotalRecords}
                />
                <div style={{ margin: "10px 0px 10px 10px", fontWeight: "bold" }}>
                  Total Records: {totalRecords > 0 ? totalRecords : (pmMaintenanceDataList?.data?.packagingPMMaintenanceDTOList?.length || pmMaintenanceDataList?.data?.cepgPMMaintenanceDTOList?.length || 0)}
                </div>
              </div>
            )}
          </div>
        </Grid>
      </Grid> 
        }
    </>
    
  )
}
